import React from 'react';
import Agents from 'images/homeval/agents.png';
import { formatPhoneNumber } from 'utils/utils.js';

const NotFound = ({ address, isKVCoreFunnel, kvCoreAgentInfo = {}, kvCorePlatformName }) => {
  const handleGoBack = () => window.history.back();
  const hasAgentInfo = isKVCoreFunnel && kvCoreAgentInfo && Object.keys(kvCoreAgentInfo).length > 0;

  return (
    <div className="report-wrapper">
      <div className="inner-wrapper">
        <h1 className="title">Sorry, we couldn't create a report for '{address}' 😕</h1>
        <p className="subtitle">The address you entered is either mispelled, or there's not enough data for us to generate a report.</p>
        <span className="go-back">
          <a href="#" onClick={handleGoBack}>Go back to edit address</a>
        </span>
      </div>
      {hasAgentInfo ? (
        <div className="agent-info">
          <div className="w-96 p-4 border-[1px] border-[solid] border-[#F9ECE5] bg-[#F9ECE5] rounded-[30px] inline-flex flex-col justify-center items-center gap-2">
            {kvCoreAgentInfo.photo && (
              <div
                className="flex w-[74px] h-[74px] py-[25px] flex-col justify-end items-center gap-1 flex-shrink-0 rounded-[100px]"
                style={{
                  backgroundImage: `url(${kvCoreAgentInfo.photo})`,
                  backgroundPosition: '50%',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat'
                }}
              />
            )}
            <div className="flex flex-col items-center justify-center w-80">
              <div className="flex flex-col items-center self-stretch justify-center gap-5">
                <div className="flex flex-col items-start justify-start gap-4 overflow-hidden w-72">
                  <div className="w-72 rounded-[45px] flex flex-col justify-center items-center">
                    {kvCoreAgentInfo.name && (
                      <div className="justify-start text-2xl font-bold text-center text-slate-700">
                        {kvCoreAgentInfo.name}
                      </div>
                    )}
                    {kvCorePlatformName && (
                      <div className="flex flex-col items-center justify-start">
                        <span className="text-[#667085] font-[Poppins] text-[16px] not-italic font-normal leading-[150%]">
                          {kvCorePlatformName}
                        </span>
                      </div>
                    )}
                  </div>
                  {(kvCoreAgentInfo.email || kvCoreAgentInfo.phone) && (
                    <div className="self-stretch px-4 py-4 border-t border-stone-300 flex flex-col justify-center items-center gap-2.5">
                      {kvCoreAgentInfo.email && (
                        <div className="inline-flex items-center justify-start gap-2">
                          <div className="inline-flex flex-col items-center justify-center">
                            <div className="relative overflow-hidden">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M1.66602 6.07812L8.47012 10.841C9.02109 11.2267 9.29658 11.4195 9.59624 11.4942C9.86093 11.5602 10.1378 11.5602 10.4025 11.4942C10.7021 11.4195 10.9776 11.2267 11.5286 10.841L18.3327 6.07812M5.66602 16.9115H14.3327C15.7328 16.9115 16.4329 16.9115 16.9677 16.639C17.4381 16.3993 17.8205 16.0168 18.0602 15.5464C18.3327 15.0117 18.3327 14.3116 18.3327 12.9115V7.57813C18.3327 6.17799 18.3327 5.47793 18.0602 4.94315C17.8205 4.47274 17.4381 4.09029 16.9677 3.85061C16.4329 3.57812 15.7328 3.57812 14.3327 3.57812H5.66602C4.26588 3.57812 3.56582 3.57812 3.03104 3.85061C2.56063 4.09029 2.17818 4.47274 1.9385 4.94315C1.66602 5.47793 1.66602 6.17799 1.66602 7.57813V12.9115C1.66602 14.3116 1.66602 15.0117 1.9385 15.5464C2.17818 16.0168 2.56063 16.3993 3.03104 16.639C3.56582 16.9115 4.26588 16.9115 5.66602 16.9115Z" stroke="#6471ED" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                            </div>
                          </div>
                          <div className="inline-flex flex-col items-start justify-start">
                            <span className="text-[#2A2F64] font-[Poppins] text-[14px] not-italic font-normal leading-[20px]">
                              <a href={`mailto:${kvCoreAgentInfo.email}`}>{kvCoreAgentInfo.email}</a>
                            </span>
                          </div>
                        </div>
                      )}
                      {kvCoreAgentInfo.phone && (
                        <div className="pb-2.5 inline-flex justify-end items-center gap-2">
                          <div className="inline-flex flex-col items-center justify-center">
                            <div className="relative overflow-hidden">
                              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                <path d="M3.5 4.5C3.5 3.39543 4.39543 2.5 5.5 2.5H15.5C16.6046 2.5 17.5 3.39543 17.5 4.5V16.5C17.5 17.6046 16.6046 18.5 15.5 18.5H5.5C4.39543 18.5 3.5 17.6046 3.5 16.5V4.5Z" stroke="#6471ED" strokeWidth="2"/>
                                <path d="M7.5 5.5H13.5" stroke="#6471ED" strokeWidth="2" strokeLinecap="round"/>
                                <path d="M7.5 8.5H13.5" stroke="#6471ED" strokeWidth="2" strokeLinecap="round"/>
                                <path d="M7.5 11.5H10.5" stroke="#6471ED" strokeWidth="2" strokeLinecap="round"/>
                              </svg>
                            </div>
                          </div>
                          <div className="inline-flex flex-col items-start justify-start">
                            <span className="text-[#2A2F64] font-[Poppins] text-[14px] not-italic font-normal leading-[20px]">
                              <a href={`tel:${kvCoreAgentInfo.phone}`}>{formatPhoneNumber(kvCoreAgentInfo.phone)}</a>
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="inner-wrapper">
          <img
            src={Agents}
            alt="agents"
            className="agents"
          />
          <h2 className="title h2">Connect with an agent instead?</h2>
          <p className="subtitle">If you'd like to get an expert opinion on the property you're searching, we can match you with a top local agent for free.</p>
        </div>
      )}
      <div className="inner-wrapper">
        <div className="flex cta-wrapper">
          <a className="cta-filled" href="/selling">I am Selling</a>
          <a className="cta-filled" href="/buying">I am Buying</a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
